import type { SubscriptionPeriodEnum } from '@/type';
import { PRODUCT_CATEGORY } from '@/types/react-native-purchases-enums';
import type { IconName } from './icons';

export type { IconName };

export enum LabelColor {
  GREEN = 'GREEN',
  RED = 'RED',
  LIGHTBLUE = 'LIGHTBLUE',
}

export interface Feature {
  key: string;
  textKey: string;
  icon?: React.ElementType;
  iconName: IconName;
  labelColor?: LabelColor;
  labelIcon?: React.ElementType;
}

export interface Product {
  identifier?: string;
  description?: string;
  title?: string;
  stripePriceId?: string | null;
  price?: number | null;
  priceString?: string | null;
  priceInterval?: string | null;
  priceIntervalCount?: number;
  currencyCode?: string;
  productType?: string;
  subscriptionPeriod?: SubscriptionPeriodEnum | string;
  introPrice?: number;
  productCategory?: PRODUCT_CATEGORY;
}

export interface SubscriptionPlan {
  id: string;
  titleKey?: string;
  descrKey?: string;
  product?: Product;
  subtitleKey?: string;
  intervalKey?: string;
  labelKey?: string;
  info?: string;
  featuresList: Feature[];
  audience?: AudienceId;
}

export enum Audience {
  Profi = 'profi',
  Student = 'student',
}
export type AudienceId = Audience;

export const PlanProductId = {
  HUM_FREE_STUDENT: 'HUMEO_FREE_STUDENT',
  HUM_FREE_PROFI: 'HUMEO_FREE_PROFI',
  HUM_PRO: 'HUMEO_PRO',
  HUM_SYSTEM: 'HUMEO_SYSTEM',
  HUM_SPRINT: 'HUMEO_SPRINT',
  HUM_CME: 'HUM_CME',
} as const;
export type PlanProductId = (typeof PlanProductId)[keyof typeof PlanProductId];
